import {
    Col,
    Row,
    Space,
    Typography,
} from 'antd';
import { FC, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { centerByCountry } from '../../utils/countries.utils';
import { SearchLocation } from '../SearchLocation';
import { useWorkspaceStore } from '../../store/workspace.store';
import { DriversMap } from '../DriversMap';
import { useDriversContext } from './context/drivers.ctx';
import { DriverMarker } from '../DriverMarker';
import { ICoordinates } from '../../interfaces/map.interface';
import { IDriver } from '../../interfaces/driver.interface';

const { Text } = Typography;

const DEFAULT_ZOOM = 12;
const CommandCenter: FC = () => {
    const { t } = useTranslation('drivers', { keyPrefix: 'DRIVERS' });

    const workspace = useWorkspaceStore((state) => state.data);

    const { drivers } = useDriversContext();

    const [center, setCenter] = useState<ICoordinates>(centerByCountry(workspace?.country as string));
    const [zoom, setZoom] = useState<number>(DEFAULT_ZOOM);
    const [setMapsLoaded] = useState<any>();

    const handleUpdateLocation = ({ center, zoom }: { center: ICoordinates; zoom: number }) => {
        setCenter(center);
        setZoom(zoom);
    };

    const setDefaultLocation = () => {
        setCenter(centerByCountry(workspace?.country as string));
        setZoom(DEFAULT_ZOOM);
    };

    return (
        <div className="section">
            <Space direction="vertical" size={24} style={{ width: '100%' }}>
                <div className="help">
                    <Text>
                        <Trans
                            t={t}
                            i18nKey="COMMAND_CENTER_HELP"
                            components={{
                                b: <b />,
                            }}
                        />
                    </Text>
                </div>

                <Row justify="start" align="middle" gutter={16}>
                    <Col flex="1">
                        <SearchLocation
                            updateLocation={handleUpdateLocation}
                            setDefaultLocation={setDefaultLocation}
                        />
                    </Col>
                </Row>
                <div style={{ height: 650 }}>
                    <DriversMap
                        setMapsLoaded={setMapsLoaded}
                        center={center}
                        zoom={zoom}
                    >
                        {
                            drivers && drivers.map((driver: IDriver) => (
                                <DriverMarker
                                    key={driver._id}
                                    driverID={driver._id}
                                    driverUniqueID={driver.userUniqueID}
                                    name={driver.name}
                                    lastName={driver.lastName}
                                    email={driver.email}
                                    mobile={driver.fullMobile}
                                    isBusy={driver.isBusy}
                                    onDutyFlag={driver.onDutyFlag}
                                    lat={driver?.currentDriverLocation?.coordinates.lat || 0}
                                    lng={driver?.currentDriverLocation?.coordinates.lng || 0}
                                    driverMarkerSelected=""
                                    updatedDriverMarkerSelected={() => { }}
                                />
                            ))
                        }
                    </DriversMap>
                </div>
            </Space>
        </div>
    );
};

export { CommandCenter };
